import { useEffect, useState, useCallback } from 'react';

/**
 * Session-level "Show Profits" toggle. Super Admin can flip this to hide all
 * profit figures across the app in a single click (useful for screen sharing).
 * State persists in sessionStorage (cleared when browser tab closes).
 *
 * Consumers simply render based on `showProfits`; the toggle button lives on
 * the Pollen Dots Dashboard next to "Add Tour".
 */
const STORAGE_KEY = 'pollen_show_profits';
const EVENT = 'pollen-profits-toggle';

export const readShowProfits = () => {
  try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
};

export const setShowProfitsGlobal = (v) => {
  try { sessionStorage.setItem(STORAGE_KEY, v ? '1' : '0'); } catch { /* noop */ }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: Boolean(v) }));
};

export const useShowProfits = () => {
  const [v, setV] = useState(readShowProfits);
  useEffect(() => {
    const handler = (e) => setV(Boolean(e.detail));
    const storageHandler = (e) => { if (e.key === STORAGE_KEY) setV(e.newValue === '1'); };
    window.addEventListener(EVENT, handler);
    window.addEventListener('storage', storageHandler);
    return () => {
      window.removeEventListener(EVENT, handler);
      window.removeEventListener('storage', storageHandler);
    };
  }, []);
  const toggle = useCallback(() => setShowProfitsGlobal(!v), [v]);
  return [v, setShowProfitsGlobal, toggle];
};
